import moment from 'moment';
import { getIntl } from 'umi';

const DATE_RANGE_VALUES = {
  today: [moment(), moment()],
  yesterday: [moment().subtract(1, 'day'), moment().subtract(1, 'day')],
  last_7_days: [moment().subtract(7, 'day'), moment()],
  last_15_days: [moment().subtract(15, 'day'), moment()],
  last_30_days: [moment().subtract(30, 'day'), moment()],
  current_week: [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
  current_month: [moment().startOf('month'), moment().endOf('month')],
  current_year: [moment().startOf('year'), moment().endOf('year')],
  previous_month: [
    moment().subtract(1, 'months').startOf('month'),
    moment().subtract(1, 'months').endOf('month'),
  ],
  last_3_months: [
    moment().subtract(3, 'months').startOf('month'),
    moment().subtract(1, 'month').endOf('month'),
  ],
  last_6_months: [
    moment().subtract(6, 'months').startOf('month'),
    moment().subtract(1, 'month').endOf('month'),
  ],
  last_12_months: [
    moment().subtract(12, 'months').startOf('month'),
    moment().subtract(1, 'month').endOf('month'),
  ],
  custom_range: [],
};

const getDateRange = () => [
  { key: 'today', label: getIntl().formatMessage({ id: 'global.text.today' }), value: 'today' },
  {
    key: 'yesterday',
    label: getIntl().formatMessage({ id: 'global.text.yesterday' }),
    value: 'yesterday',
  },
  {
    key: 'last_7_days',
    label: getIntl().formatMessage({ id: 'global.text.last7Days' }),
    value: 'last_7_days',
  },
  {
    key: 'last_15_days',
    label: getIntl().formatMessage({ id: 'global.text.last15Days' }),
    value: 'last_15_days',
  },
  {
    key: 'last_30_days',
    label: getIntl().formatMessage({ id: 'global.text.last30Days' }),
    value: 'last_30_days',
  },
  {
    key: 'current_week',
    label: getIntl().formatMessage({ id: 'global.text.currentWeek' }),
    value: 'current_week',
  },
  {
    key: 'current_month',
    label: getIntl().formatMessage({ id: 'global.text.currentMonth' }),
    value: 'current_month',
  },
  {
    key: 'current_year',
    label: getIntl().formatMessage({ id: 'global.text.currentYear' }),
    value: 'current_year',
  },
  {
    key: 'previous_month',
    label: getIntl().formatMessage({ id: 'global.text.lastMonth' }),
    value: 'previous_month',
  },
  {
    key: 'last_3_months',
    label: getIntl().formatMessage({ id: 'global.text.last3Months' }),
    value: 'last_3_months',
  },
  {
    key: 'last_6_months',
    label: getIntl().formatMessage({ id: 'global.text.last6Months' }),
    value: 'last_6_months',
  },
  {
    key: 'last_12_months',
    label: getIntl().formatMessage({ id: 'global.text.last12Months' }),
    value: 'last_12_months',
  },
  {
    key: 'custom_range',
    label: getIntl().formatMessage({ id: 'global.text.customRange' }),
    value: 'custom_range',
  },
];

const CoreDates = (() => {
  return {
    DATE_RANGE_VALUES,
    get DATE_RANGE() {
      return getDateRange();
    },
  };
})();

export default CoreDates;
